<template>
<div class="chapter">
<div class="inner_page">
<h1 class="Nonprinting">Cover</h1><figure data-type="cover" id="bookcover01"><img src="cover.jpg"/></figure>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?be55c416